import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const createMachine = async (courseId, data) => {
    const response = await axiosAgent.post(
        `${ApiConfig.machine.createMachine}/${courseId}`,
        data
    );
    return response.data;
};

export const deleteMachine = async (machineId) => {
    const response = await axiosAgent.delete(
        `${ApiConfig.machine.deleteMachine}/${machineId}`
    );
    return response.data;
};

export const getResourceImages = async () => {
    const response = await axiosAgent.get(ApiConfig.resource.images);
    return response.data;
};
